import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { TableCell, TableRow } from '@mui/material';
import { ADMIN_ITEMS_WRITE, ADMIN_ITEMS_READ } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';
import { ThinCheckbox } from 'components/common/Styles';
import TextTableCell from 'components/common/table/TextTableCell';

const ItemComponent = ({ data, onDelete }) => {
  const [t] = useTranslation();
  const historyContext = useHistoryWithContext();
  const canWrite = usePermission(ADMIN_ITEMS_WRITE);
  const canRead = usePermission(ADMIN_ITEMS_READ);

  const handleEdit = useCallback(() => {
    historyContext.push(`/items/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TextTableCell content={data.code} />
      <TableCell>
        <Typography title={data.name}>{data.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography title={data.typeCode}>{data.typeCode}</Typography>
      </TableCell>
      <TableCell>
        <Typography title={data.typeName}>{data.typeName}</Typography>
      </TableCell>
      <TableCell align='center'>
        <ThinCheckbox checked={data.enabled} size='small' disabled />
      </TableCell>
      <TableCell>
        <IconButton
          disabled={!canRead}
          size='small'
          type='edit'
          variant='text'
          color='primary'
          tooltip={t('Items.Edit')}
          onClick={handleEdit}
        />
        <IconButton
          size='small'
          disabled={!canWrite}
          type='delete'
          variant='text'
          color='primary'
          tooltip={t('Items.Delete')}
          onClick={() => onDelete(data.id)}
        />
      </TableCell>
    </TableRow>
  );
};

ItemComponent.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func
};

export default ItemComponent;
